// Umami at pulse.locotap.com: page views on its own (the path only), plus the steps of the funnel (docs/pulse-funnel.md). Cookieless;
// once signed in, the account's opaque id joins one person's visits. Steps taken before the script loads wait in
// window.pulseQueue (lib/tally.js puts the tool steps there).
const website = document.querySelector('meta[name="locotap-pulse"]')?.content

if (website && window.self === window.top) {
  const step = document.querySelector('meta[name="locotap-pulse-event"]')
  if (step?.content) (window.pulseQueue ||= []).push([step.content, step.dataset.via ? { via: step.dataset.via } : undefined])

  // Signed out, a tap on a Sign in or Start free link: where on the page it was. The page itself comes with the event.
  if (!document.querySelector('meta[name="locotap-pulse-id"]')) {
    document.addEventListener("click", (e) => {
      const link = e.target instanceof Element ? e.target.closest('a[href^="/sign-in"]') : null
      if (!link || link.pathname !== "/sign-in") return
      const from = link.closest("header") ? "header" : link.closest("footer") ? "footer" : "page"
      ;(window.pulseQueue ||= []).push(["sign-in-click", { from }])
    }, true)
  }

  const script = document.createElement("script")
  script.async = true
  script.src = "https://pulse.locotap.com/p.js"
  script.dataset.websiteId = website
  // Addresses go without their ?query: Find keeps what's typed there (?ask=), and a page view counts only when the path
  // itself changes, never as the words change.
  script.dataset.excludeSearch = "true"
  script.onload = () => {
    const umami = window.umami
    if (!umami) return
    const id = document.querySelector('meta[name="locotap-pulse-id"]')?.content
    if (id) umami.identify(id)
    for (const [name, data] of window.pulseQueue ?? []) umami.track(name, data)
    window.pulseQueue = { push: ([name, data]) => umami.track(name, data) }
  }
  document.head.appendChild(script)
}
